import { createRequestActions, RequestType } from 'store/utils';
import { ISetActivityStatusPayload } from 'modules/settings/submodules/clients/activities/components/ClientActivitiesTable/components/UpdateStatusSelect/store/models';
import { IActivity } from 'store/entities/configuration/configurationModel';

export const setActivityStatus = createRequestActions<ISetActivityStatusPayload, IActivity>(
    RequestType.PATCH,
    'ACTIVITY_STATUS',
    'settings/');
